import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ProductScroll from "./components/ProductScroll";
import SeoContent from "./components/SeoContent";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuyfinds.wiki";
const faviconUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png";

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Kakobuy Finds Wiki",
  url: siteUrl,
  description: "Największy Kakobuy Spreadsheet w Polsce. Ponad 20 000 produktów, aktualizowany codziennie, 100% darmowy.",
  inLanguage: "pl-PL",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Kakobuy Finds Wiki",
  url: siteUrl,
  logo: faviconUrl,
  description: "Największy katalog spreadsheetów zakupowych w Polsce — Kakobuy, CSSBuy, Superbuy, Oopbuy, Mulebuy, AllChinaBuy, Joyabuy, Sugargoo.",
  sameAs: [
    "https://twitter.com",
    "https://facebook.com",
    "https://instagram.com",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    email: "kontakt@kakobuyfinds.wiki",
    contactType: "customer service",
    availableLanguage: ["Polish"],
  },
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={webSiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ProductScroll />
      <SeoContent />
      <CtaSection />
      <Footer />
    </main>
  );
}